module.exports = __webpack_public_path__ + "img/img4.d8841696.png";